import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export type AddClientRouteSearch = {
  /** The group the new client joins, e.g. when added from its group page. */
  group?: number;
};

export const Route = createFileRoute('/_app/clients/add')({
  validateSearch: (search): AddClientRouteSearch => {
    const group = Number(search.group);
    return Number.isInteger(group) && group > 0 ? { group } : {};
  },
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle('clients.add_client.page_title', 'Add Client'),
      },
    ],
  }),
});
